import { of, timer } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

import { redirect } from '@/common/utils';
import { Guard, rootRoutePaths, rootRoutes } from '@/core/navigation';
import { getLoginPageUrl, userProfile } from '@/core/services/authentication';

const WAIT_TIME = 5000;

export const unauthenticatedGuard: Guard = ({ store }) => {
  return userProfile({ store }).pipe(
    switchMap((data) => {
      if (data === undefined) {
        redirect(getLoginPageUrl());
        return timer(WAIT_TIME).pipe(mapTo(null));
      }

      return of({ redirectUrl: rootRoutePaths[rootRoutes.AUTHENTICATED] });
    })
  );
};
